import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactPdfViewerParams } from '@ui/chat/modules/ReactPdfViewer'
import { LoadingSpinner, Markdown } from '@ui/components'

interface ReasoningDropDownProps {
  readonly reasoningContent?: string | undefined;
  readonly isThinking: boolean;
  readonly isDeepResearch: boolean;
  readonly onSourceSelected?: ((params: ReactPdfViewerParams) => void) | undefined;
}

export default function ReasoningDropDown({ reasoningContent, isThinking, isDeepResearch, onSourceSelected }: ReasoningDropDownProps) {
	const [isReasoningOpen, setIsReasoningOpen] = useState(false)
	const contents = reasoningContent?.replaceAll('\n\n', '<br><br>')

	return (
		<div className="flex flex-col">
			<button
				className={ `bg-gray-50 w-fit hover:bg-gray-100 flex items-center gap-2 border px-4 py-3 text-xs border-black/10 cursor-pointer rounded-xl
				 active:scale-[0.97] transition-all duration-300 ease-out ` }
				onClick={ e => {
					e.stopPropagation()
					setIsReasoningOpen(!isReasoningOpen)
				} }>
				<FontAwesomeIcon className="text-gray-400 w-3 h-3" icon="magnifying-glass" />
				<div>{ isDeepResearch ? 'Reasoning' : 'Thinking' }<span className={ `${isThinking ? 'opacity-100' : 'opacity-0'}` }>...</span></div>
				{ isThinking ? <LoadingSpinner size="small" /> : null }
				<FontAwesomeIcon className="text-gray-400 w-3 h-3" icon={ `${isReasoningOpen ? 'chevron-up' : 'chevron-down'}` } />
			</button>
			{ reasoningContent
				? <div className={ ` ${isReasoningOpen ? 'py-3' : 'py-0 overflow-hidden opacity-0 h-0'} italic text-sm text-gray-500 transition-all duration-300 ease-out border-l-2 px-6 ml-6` }>
					<Markdown onSourceSelected={ onSourceSelected }>
						{ contents ?? '' }
					</Markdown>
				</div>
				: null }
		</div>
	)
}
